var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "attach_email"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_6748",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_6748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "attach_email_2",
    d: "M9.20817 9.35417L2.31234 4.83333V13.5625H12.2707V15.5208H0.354004V1.125H18.0832V8.10417H16.104V4.83333L9.20817 9.35417ZM9.20817 7.54167L16.104 3.10417H2.31234L9.20817 7.54167ZM16.6248 19.0208C15.7498 19.0208 15.0137 18.7087 14.4165 18.0844C13.8193 17.4601 13.5207 16.7097 13.5207 15.8333V11.1667C13.5207 10.6383 13.7065 10.1868 14.0782 9.81208C14.4498 9.43736 14.9048 9.25 15.443 9.25C15.9695 9.25 16.4127 9.43736 16.7725 9.81208C17.1324 10.1868 17.3123 10.6383 17.3123 11.1667V15.9583H15.8332V11.1042C15.8332 10.9486 15.8019 10.8125 15.7394 10.6958C15.6769 10.5792 15.5762 10.5208 15.4373 10.5208C15.2984 10.5208 15.1908 10.5792 15.1144 10.6958C15.038 10.8125 14.9998 10.9486 14.9998 11.1042V15.875C14.9998 16.3775 15.1483 16.8122 15.4453 17.179C15.7421 17.5458 16.1344 17.7292 16.6223 17.7292C17.0823 17.7292 17.4512 17.5521 17.729 17.1979C18.0068 16.8438 18.1457 16.4306 18.1457 15.9583V11.7292H19.6457V15.9583C19.6457 16.8003 19.354 17.5212 18.7707 18.121C18.1873 18.7209 17.4721 19.0208 16.6248 19.0208ZM2.31234 4.83333V3.10417V13.5625V4.83333Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachEmail);
export default __webpack_public_path__ + "static/media/attach_email.eb23714c0782ac076295896cb6af3bb5.svg";
export { ForwardRef as ReactComponent };